// src/composables/useMemberNoteReview.js
//
// Espelha, do lado do TITULAR, a regra de negócio que autoriza classificar uma
// observação como Certo/Errado (ver EnsureObservationTypeAllowedAsync no backend):
// só o titular (fora de contexto managed), revisando uma nota em atividade
// própria, cujo autor a criou ENQUANTO ATUAVA COMO MEMBRO GERENCIADO DELE
// especificamente — refletido em note.createdAsMemberOfUserId, gravado no
// momento da criação. Não usamos o vínculo atual (managed_account_relationships),
// pois um usuário pode ser membro de um titular e, ainda assim, ter criado esta
// nota logado como titular (conta própria, fora do contexto managed) — nesse
// caso a nota não deve ser tratada como "nota de membro".

import { computed } from "vue";
import { useUserStore } from "@/stores/useUserStore";

export function useMemberNoteReview() {
  const userStore = useUserStore();

  const isManagedMember = computed(
    () => userStore.currentUser?.loginContext === "managed"
  );

  const currentUserId = computed(() => userStore.currentUser?.userId ?? null);

  // Titular revisando, em atividade própria, uma nota criada por um autor que
  // estava atuando como membro gerenciado dele no momento da criação.
  function canReviewNoteAsCorrection(
    noteCreatedAsMemberOfUserId,
    activityCreatedByUserId
  ) {
    if (isManagedMember.value) return false;
    if (
      activityCreatedByUserId == null ||
      currentUserId.value == null ||
      Number(activityCreatedByUserId) !== Number(currentUserId.value)
    ) {
      return false;
    }
    return (
      noteCreatedAsMemberOfUserId != null &&
      Number(noteCreatedAsMemberOfUserId) === Number(currentUserId.value)
    );
  }

  return {
    isManagedMember,
    currentUserId,
    canReviewNoteAsCorrection,
  };
}
